<template>
  <div>
    <ul
      class="side_menu"
      :key="'sidemenu_sub_category_' + category.label"
      v-for="category in items"
    >
      <template v-if="decodeURI($page.url) == category.to">
        <li class="relative side_menu side_menu_active">
          <div :class="'ml-' + level">
            <div class="active_square"></div>
            {{ category.label }}
          </div>
        </li>
      </template>
      <template v-else>
        <Link
          class="side_menu side_menu_inactive cursor-pointer"
          as="li"
          :href="category.to"
        >
          <div :class="'ml-' + level">
            {{ category.label }}
          </div>
        </Link>
      </template>
      <ul v-if="category.items">
        <sub-menu
          class="w-full"
          :level="level + 1"
          :items="category.items"
          :key="'sidemenu_sub_category_' + category.label + '_sub'"
        />
      </ul>
    </ul>
  </div>
</template>

<script>
export default {
  name: "sub-menu",
  components: {
    //
  },
  props: {
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    level: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      //
    };
  },
  methods: {
    //
  },
  mounted() {
    //
  },
};
</script>

<style lang="postcss">
.active_square {
  @apply absolute w-1.5 h-6 left-0 bg-fh-blue;
}
</style>